import React from "react";

export const ConfirmationInfoTab = () => (
    <div className="space-y-6">

    </div>
);
